import type { ComponentType, ReactElement } from 'react';
import { ClearIndicatorProps, components } from 'react-select';
import styled from 'styled-components';
import { Icon } from '../../../icons/Icon.component';
import { classNamePrefix, SelectIconButton } from '../Select.styles';
import { ILegacySelectOptionData, LegacySelectComponentProps, LegacySelectOptionGroup } from '../Select.types';

type SelectClearIndicatorProps = LegacySelectComponentProps<
  ClearIndicatorProps<ILegacySelectOptionData, boolean, LegacySelectOptionGroup>
>;

const StyledClearIndicator = styled(components.ClearIndicator as ComponentType<SelectClearIndicatorProps>)`
  border-right: 1px solid
    ${({ theme, selectProps: { variant } }) => theme.select.variants[variant]?.indicator.clear.borderColor};
  &.${classNamePrefix}__clear-indicator {
    margin: ${({ theme }) => theme.space[2]}px 0;
    padding: 0 ${({ theme }) => theme.space[2]}px;
  }
`;

export const SelectClearIndicator = (props: SelectClearIndicatorProps): ReactElement => (
  <StyledClearIndicator {...props}>
    <SelectIconButton subject="select-clear-button" variant={props.selectProps.variant}>
      <Icon icon={'xmark-regular'} size={12} />
    </SelectIconButton>
  </StyledClearIndicator>
);

SelectClearIndicator.displayName = 'ClearIndicator';
